export interface CliniciansBar {
  phone: string;
  style: string;
  blogs: string;
}

export interface HeaderTopBarData {
  cliniciansBar: CliniciansBar;
}

export const topBarData: HeaderTopBarData = {
  cliniciansBar: {
    blogs: 'Blogs',
    phone: '+44 20 7164 6114',
    style: '',
  },
};
